/*
 * Copyright © 2016-2018 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
export default function addLocaleFinnish(locales) {

    var fi_FI = {
        "access": {
            "unauthorized": "Estetty",
            "unauthorized-access": "Pääsy estetty",
            "unauthorized-access-text": "Kirjaudu sisään käyttääksesi tätä toimintoa!",
            "access-forbidden": "Pääsy estetty",
            "access-forbidden-text": "Käyttöoikeutesi eivät riitä toiminnon suorittamiseen<br/>Palaa takaisin valinnalla Peruuta tai jatka ylläpitäjänä Kirjautumalla eri käyttäjätunnuksella.",
            "refresh-token-expired": "Istunto on vanhentunut",
            "refresh-token-failed": "Istunnon päivitys ei onnistunut"
        },
        "action": {
            "activate": "Aktivoi",
            "suspend": "Keskeytä",
            "save": "Talleta",
            "saveAs": "Talleta nimellä",
            "cancel": "Peruuta",
            "ok": "OK",
            "delete": "Poista",
            "add": "Lisää",
            "yes": "Kyllä",
            "no": "Ei",
            "update": "Päivitä",
            "remove": "Poista",
            "search": "Etsi",
            "assign": "Aseta",
            "unassign": "Poista",
            "share": "Jako",
            "make-private": "Aseta yksityiseksi",
            "apply": "Talleta",
            "apply-changes": "Talleta muutokset",
            "edit-mode": "Muokkaustila",
            "enter-edit-mode": "Siirry muokkaamaan",
            "decline-changes": "Hylkää muutokset",
            "close": "Sulje",
            "back": "Takaisin",
            "run": "Suorita",
            "sign-in": "Kirjaudu!",
            "edit": "Muokkaa",
            "view": "Katso",
            "create": "Luo",
            "drag": "Vedä",
            "refresh": "Päivitä",
            "undo": "Peruuta",
            "copy": "Kopioi",
            "paste": "Liitä",
            "copy-reference": "Kopio viite",
            "paste-reference": "Liitä viite",
            "import": "Tuo",
            "export": "Vie",
            "share-via": "Jaa {{provider}} välityksellä"
        },
        "aggregation": {
            "aggregation": "Yhdistelmä",
            "function": "Esitettävä tieto on",
            "limit": "Maksimiarvot",
            "group-interval": "Aikaväli",
            "min": "Minimi",
            "max": "Maksimi",
            "avg": "Keskiarvo",
            "sum": "Summa",
            "count": "Luku",
            "none": "Tyhjä"
        },
        "admin": {
            "general": "Yleinen",
            "general-settings": "Yleiset asetukset",
            "outgoing-mail": "Lähtevä posti",
            "outgoing-mail-settings": "Lähtevän postin asetukset",
            "system-settings": "Järjestelmäasetukset",
            "test-mail-sent": "Testiviesti lähetetty onnistuneesti!",
            "base-url": "Perus URL",
            "base-url-required": "Perus URL tulee asettaa.",
            "mail-from": "Lähettäjä",
            "mail-from-required": "Lähettäjän osoite tulee asettaa.",
            "smtp-protocol": "SMTP-protokolla",
            "smtp-host": "SMTP-isäntäpalvelin",
            "smtp-host-required": "SMTP-isäntäpalvelimen osoite tulee asettaa.",
            "smtp-port": "SMTP-portti",
            "smtp-port-required": "SMTP-portti tulee asettaa.",
            "smtp-port-invalid": "Asetus ei näytä pätevältä SMTP-portilta.",
            "timeout-msec": "Aikakatkaisu (msec)",
            "timeout-required": "Aikakatkaisu on pakollinen.",
            "timeout-invalid": "Aikakatkaisuasetus ei ole kelvollinen.",
            "enable-tls": "Ota käyttöön TLS",
            "send-test-mail": "Lähetä testiposti"
        },
        "alarm": {
            "alarm": "Hälytys",
            "alarms": "Hälytykset",
            "select-alarm": "Valitse hälytys",
            "no-alarms-matching": "Sopivia hälytyksiä '{{entity}}' ei löytynyt.",
            "alarm-required": "Hälytys tulee asettaa",
            "alarm-status": "Hälytyksen tila",
            "search-status": {
                "ANY": "Kaikki",
                "ACTIVE": "Aktiiviset",
                "CLEARED": "Poistetut",
                "ACK": "Kuitatut",
                "UNACK": "Kuittaamatta"
            },
            "display-status": {
                "ACTIVE_UNACK": "Aktiiviset kuittaamatta",
                "ACTIVE_ACK": "Aktiiviset kuitatut",
                "CLEARED_UNACK": "Kuittaamatta poistetut",
                "CLEARED_ACK": "Kuitattuna poistetut"
            },
            "no-alarms-prompt": "Hälytyksiä ei löytynyt",
            "created-time": "Luotu",
            "type": "Tyyppi",
            "severity": "Tärkeys",
            "originator": "Lähde",
            "originator-type": "Lähteen tyyppi",
            "details": "Tiedot",
            "status": "Tila",
            "alarm-details": "Hälytyksen tiedot",
            "start-time": "Alkoi",
            "end-time": "Päättyi",
            "ack-time": "Kuitattu",
            "clear-time": "Poistettu",
            "severity-critical": "Kriittinen",
            "severity-major": "Merkittävä",
            "severity-minor": "Vähäinen",
            "severity-warning": "Varoitus",
            "severity-indeterminate": "Määrittelemätön",
            "acknowledge": "Kuittaa",
            "clear": "Poista",
            "search": "Hae",
            "selected-alarms": "{ count, select, 1 {1 alarm} other {# alarms} } selected",
            "no-data": "Ei esitettävää dataa",
            "polling-interval": "Hälytyskyselyjen aikaväli (s)",
            "polling-interval-required": "Aikaväliasetus tulee asettaa.",
            "min-polling-interval-message": "Pienin sallittu aikaväli on 1 sekunti.",
            "aknowledge-alarms-title": "Kuittaa { count, select, 1 {1 alarm} other {# alarms} }",
            "aknowledge-alarms-text": "Oletko varma, että haluat kuitata { count, select, 1 {1 alarm} other {# alarms} }?",
            "clear-alarms-title": "Poista { count, select, 1 {1 alarm} other {# alarms} }",
            "clear-alarms-text": "Oletko Varma, että haluat poistaa { count, select, 1 {1 alarm} other {# alarms} }?"
        },
        "alias": {
            "add": "Lisää näyttönimi",
            "edit": "Muokkaa näyttönimeä",
            "name": "Näyttönimi",
            "name-required": "Näyttönimi tulee asettaa",
            "duplicate-alias": "Näyttönimi on jo olemassa.",
            "filter-type-single-entity": "Yksittäinen laite",
            "filter-type-entity-list": "Joukko laiteita",
            "filter-type-entity-name": "Nimi",
            "filter-type-state-entity": "Mittariston tila-asetus",
            "filter-type-state-entity-description": "Lähteen kuvaus mittariston tila-asetuksista",
            "filter-type-asset-type": "Ryhmittelyn tyyppi",
            "filter-type-asset-type-description": "Ryhmittelyt tyyppiä '{{assetType}}'",
            "filter-type-asset-type-and-name-description": "Ryhmittelyt tyyppiä '{{assetType}}' alkaen '{{prefix}}'",
            "filter-type-device-type": "Laitetyyppi",
            "filter-type-device-type-description": "Laitteet tyyppiä '{{deviceType}}'",
            "filter-type-device-type-and-name-description": "Laiteet tyyppiä ’{{deviceType}}' alkaen '{{prefix}}'",
            "filter-type-relations-query": "Liitosasetus",
            "filter-type-relations-query-description": "{{entities}} joiden {{relationType}} asetus on {{direction}} {{rootEntity}}",
            "filter-type-asset-search-query": "Asset search query",
            "filter-type-asset-search-query-description": "Ryhmittelyt tyyppiä {{assetTypes}} joiden {{relationType}} asetus on {{direction}} {{rootEntity}}",
            "filter-type-device-search-query": "Device search query",
            "filter-type-device-search-query-description": "Laitteet tyyppiä {{deviceTypes}} joiden {{relationType}} asetus on {{direction}} {{rootEntity}}",
            "entity-filter": "Kohteiden suodatin",
            "resolve-multiple": "Esitä useana kohteena",
            "filter-type": "Suodattimen tyyppi",
            "filter-type-required": "Suodattimen tyyppi tulee asettaa.",
            "entity-filter-no-entity-matched": "Sopivia kohteita ei löytynyt.",
            "no-entity-filter-specified": "Suodattimen tyyppiä ei ole määritetty",
            "root-state-entity": "Käytä mittariston oletustila-asetuksia",
            "root-entity": "Oletuslähde",
            "state-entity-parameter-name": "Käytettävän tila-asetuksen nimi",
            "default-state-entity": "Oletustilan asetukset",
            "default-entity-parameter-name": "Oletusasetuksen nimi",
            "max-relation-level": "Tasojen enimmäismäärä",
            "unlimited-level": "Rajoittamaton",
            "state-entity": "Tila-asetus",
            "all-entities": "Kaikki kohteet",
            "any-relation": "Mikä tahansa"
        },
        "asset": {
            "asset": "Ryhmittely",
            "assets": "Ryhmittelyt",
            "management": "Ryhmittelyjen hallinta",
            "view-assets": "Katso ryhmittelyt",
            "add": "Lisää ryhmittely",
            "assign-to-customer": "Kohdista asiakkaalle",
            "assign-asset-to-customer": "Kohdista ryhmittely(t) asiakkaalle",
            "assign-asset-to-customer-text": "Valitse asiakkaalle kohdistettavat ryhmittelyt",
            "no-assets-text": "Ryhmittelyjä ei löytynyt",
            "assign-to-customer-text": "Valitse asiakas",
            "public": "Julkinen",
            "assignedToCustomer": "Kohdistettu asiakkaalle",
            "make-public": "Aseta ryhmittely julkiseksi",
            "make-private": "Aseta ryhmittely yksityiseksi",
            "unassign-from-customer": "Poista kohdistus asiakkaalta",
            "delete": "Poista ryhmittely",
            "asset-public": "Ryhmittely on julkinen",
            "asset-type": "Ryhmittelytyyppi",
            "asset-type-required": "Ryhmittelytyyppi tulee asettaa.",
            "select-asset-type": "Valitse ryhmittelytyyppi",
            "enter-asset-type": "Syötä ryhmittelytyyppi",
            "any-asset": "Mikä tahansa ryhmittely",
            "no-asset-types-matching": "Ryhmittelytyyppiä '{{entitySubtype}}' ei löytynyt.",
            "asset-type-list-empty": "Ryhmittelytyyppiä ei ole valittu.",
            "asset-types": "Ryhmittelytyypit",
            "name": "Nimi",
            "name-required": "Nimi tulee asettaa.",
            "description": "Kuvaus",
            "type": "Tyyppi",
            "type-required": "Tyyppi vaaditaan.",
            "details": "Tiedot",
            "events": "Tapahtumat",
            "add-asset-text": "Lisää uusi ryhmittely",
            "asset-details": "Ryhmittelyn tiedot",
            "assign-assets": "Kohdista ryhmittelyt",
            "assign-assets-text": "Kohdista { count, select, 1 {1 asset} other {# assets} } asiakkaalle",
            "delete-assets": "Poista ryhmittelyt",
            "unassign-assets": "Poista kohdistus ryhmittelyiltä",
            "unassign-assets-action-title": "Poista kohdistus { count, select, 1 {1 asset} other {# assets} } asiakkaalta",
            "assign-new-asset": "Kohdista uusi ryhmittely",
            "delete-asset-title": "Oletko varma, että haluat poistaa ryhmittelyn '{{assetName}}'?",
            "delete-asset-text": "Vahvistettuasi ryhmittely ja siihen liittyvät tiedot poistetaan pysyvästi.",
            "delete-assets-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 asset} other {# assets} }?",
            "delete-assets-action-title": "Poista { count, select, 1 {1 asset} other {# assets} }",
            "delete-assets-text": "Vahvistettuasi kaikki valitut ryhmittelyt ja niihin liittyvät tiedot poistetaan pysyvästi.",
            "make-public-asset-title": "Oletko varma, että haluat asettaa ryhmittelyn’{{assetName}}' julkiseksi?",
            "make-public-asset-text": "Vahvistettuasi ryhmittely ja siihen liittyvät tiedot avataan julkisiksi.",
            "make-private-asset-title": "Oletko varma, että haluat asettaa ryhmittelyn '{{assetName}}' yksityiseksi?",
            "make-private-asset-text": "Vahvistettuasi ryhmittely ja siihen liittyvät tiedot muutetaan yksityisiksi.",
            "unassign-asset-title": "Oletko varma, että haluat poistaa kohdistuksen ryhmittelyltä '{{assetName}}'?",
            "unassign-asset-text": "Vahvistettuasi ryhmittely ei enää ole asiakkaan käytettävissä.",
            "unassign-asset": "Poista kohdistus ryhmittelyltä",
            "unassign-assets-title": "Poista kohdistus ryhmittelyiltä { count, select, 1 {1 asset} other {# assets} }?",
            "unassign-assets-text": "Vahvistettuasi ryhmittelyt eivät enää ole asiakkaan käytettävissä.",
            "copyId": "Kopio ryhmittelyn tunniste",
            "idCopiedMessage": "Ryhmittelyn tunniste on kopioitu leikepöydälle",
            "select-asset": "Valitse ryhmittely",
            "no-assets-matching": "Ryhmittelyä '{{entity}}' ei löytynyt.",
            "asset-required": "Ryhmittely tulee asettaa",
            "name-starts-with": "Ryhmittelyn nimi alkaa"
        },
        "attribute": {
            "attributes": "Attribuutit",
            "latest-telemetry": "Uudet sanomat",
            "attributes-scope": "Laitteen attribuuttien laajuus",
            "scope-latest-telemetry": "Uusimmat sanomat",
            "scope-client": "Laitteen attribuutit",
            "scope-server": "Palvelimen attribuutit",
            "scope-shared": "Jaetut attribuutit",
            "add": "Lisää attribuutti",
            "key": "Avain",
            "last-update-time": "Viimeksi päivitetty",
            "key-required": "Attribuuttiavain on pakollinen.",
            "value": "Arvo",
            "value-required": "Attribuutin arvo on pakollinen.",
            "delete-attributes-title": "Haluatko varmasti poistaa { count, select, 1 {1 attribuutti} other {# attribuuttia} }?",
            "delete-attributes-text": "Olethan huolellinen, vahvistettuasi kaikki valitut attribuutit poistetaan.",
            "delete-attributes": "Poista attribuutit",
            "enter-attribute-value": "Lisää attribuutin arvo",
            "show-on-widget": "Näytä mittaripohjassa",
            "widget-mode": "Widget mode",
            "next-widget": "Seuraava mittaripohja",
            "prev-widget": "Edellinen mittaripohja",
            "add-to-dashboard": "Lisää mittaristoon",
            "add-widget-to-dashboard": "Lisää mittaripohja mittaristoon",
            "selected-attributes": "{ count, select, 1 {1 attribuutti} attribuutit {# attribuuttia} } valittu",
            "selected-telemetry": "{ count, select, 1 {1 telemetriayksikkö} other {# telemetriayksikkö} } valittu"
        },
        "confirm-on-exit": {
            "message": "Sinulla on tallettamattomia muutoksia. Haluatko varmasti poistua sivulta?",
            "html-message": "Sinulla on tallettamattomia muutoksia.<br/>Haluatko varmasti poistua sivulta?",
            "title": "Tallentamattomat muutokset"
        },
        "contact": {
            "country": "Maa",
            "city": "Kaupunki",
            "state": "Osavaltio",
            "postal-code": "Postinumero",
            "postal-code-invalid": "Ainoastaan numerot ovat sallittuja.",
            "address": "Osoite",
            "address2": "Osoite 2",
            "phone": "Puhelin",
            "email": "Sähköpostiosoite",
            "no-address": "Ei osoitetta"
        },
        "common": {
            "username": "Käyttäjätunnus",
            "password": "Salasana",
            "enter-username": "Anna käyttäjätunnus",
            "enter-password": "Anna salasana",
            "enter-search": "Tee haku"
        },
        "customer": {
            "customer": "Asiakas",
            "customers": "Asiakkaat",
            "management": "Asiakkaan hallinnointi",
            "dashboard": "Asiakkaan mittaristo",
            "dashboards": "Asiakkaan mittaristot",
            "devices": "Asiakkaan laitteet",
            "assets": "Asiakkaan ryhmittelyt",
            "public-dashboards": "Julkiset mittaristot",
            "public-devices": "Julkiset laitteet",
            "public-assets": "Julkiset ryhmittelyt",
            "add": "Lisää asiakas",
            "delete": "Poista asiakas",
            "manage-customer-users": "Hallinnoi asiakkaan käyttäjiä",
            "manage-customer-devices": "Hallinnoi asiakkaan laitteita",
            "manage-customer-dashboards": "Hallinnoi asiakkaan mittaristoja",
            "manage-public-devices": "Hallinnoi julkisia laitteita",
            "manage-public-dashboards": "Hallinnoi julkisia mittaristoja",
            "manage-customer-assets": "Hallinnoi asiakkaan ryhmittelyjä",
            "manage-public-assets": "Hallinnoi julkisia ryhmittelyjä",
            "add-customer-text": "Lisää uusi asiakas",
            "no-customers-text": "Asiakkaita ei löytynyt",
            "customer-details": "Asiakkaan tiedot",
            "delete-customer-title": "Oletko varma, että haluat poistaa asiakkaan '{{customerTitle}}'?",
            "delete-customer-text": "Olethan huolellinen. Vahvistettuasi asiakas ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-customers-title": "Haluatko varmasti poistaa { count, select, 1 {1 asiakas} other {# asiakasta} }?",
            "delete-customers-action-title": "Poista { count, select, 1 {1 asiakas} other {# asiakasta} }",
            "delete-customers-text": "Olethan huolellinen. Vahvistettuasi kaikki valitut asiakkaat ja kaikki niihin liitetyt tiedot poistetaan pysyvästi.",
            "manage-users": "Käyttäjähallinta",
            "manage-assets": "Hallinnoi ryhmittelyjä",
            "manage-devices": "Laitehallinta",
            "manage-dashboards": "Mittaristojen hallinta",
            "title": "Otsikko",
            "title-required": "Otsikko on pakollinen.",
            "description": "Kuvaus",
            "details": "Tiedot",
            "events": "Tapahtumat",
            "copyId": "Kopio asiakkaan tunniste",
            "idCopiedMessage": "Asiakkaan tunniste on kopioitu leikepöydälle",
            "select-customer": "Valitse asiakas",
            "no-customers-matching": "Asiakasta '{{entity}}' ei löytynyt.",
            "customer-required": "Asiakas tulee asettaa"
        },
        "datetime": {
            "date-from": "Alkupvm",
            "time-from": "Alkuaika",
            "date-to": "Loppupvm",
            "time-to": "Loppuaika"
        },
        "dashboard": {
            "dashboard": "Mittaristo",
            "dashboards": "Mittaristot",
            "management": "Mittaristojen hallinta",
            "view-dashboards": "Selaa mittaristoja",
            "add": "Lisää mittaristo",
            "assign-dashboard-to-customer": "Kohdista mittaristo/mittaristot asiakkaalle",
            "assign-dashboard-to-customer-text": "Ole hyvä, valitse asiakkaalle kohdistettavat mittaristot",
            "assign-to-customer-text": "Ole hyvä, valitse mittaristolle kohdistettava asiakas",
            "assign-to-customer": "Kohdista asiakkaalle",
            "unassign-from-customer": "Poista kohdistus asiakkaalta",
            "make-public": "Aseta julkiseksi",
            "make-private": "Aseta yksityiseksi",
            "no-dashboards-text": "Mittaristoja ei löydy",
            "no-widgets": "Mittaripohjaa ei ole asetettu",
            "add-widget": "Lisää uusi mittaripohja",
            "title": "Otsikko",
            "select-widget-title": "Valitse mittaripohja",
            "select-widget-subtitle": "Käytettävät mittarityypit",
            "delete": "Poista mittaristo",
            "title-required": "Otsikko on pakollinen.",
            "description": "Kuvaus",
            "details": "Tiedot",
            "dashboard-details": "Mittariston kuvaus",
            "add-dashboard-text": "Lisää uusi mittaristo",
            "assign-dashboards": "Kohdista mittaristot",
            "assign-new-dashboard": "Kohdista uusi mittaristo",
            "assign-dashboards-text": "Kohdista { count, select, 1 {1 mittaristo} muu {# mittaristoa} } asiakkaalle",
            "delete-dashboards": "Poista mittaristot",
            "unassign-dashboards": "Poista mittaristojen kohdistus",
            "unassign-dashboards-action-title": "Poista { count, select, 1 {1 mittaristo} other {# mittaristoa} } asiakkaalta",
            "delete-dashboard-title": "Oletko varma, että haluat poistaa mittariston '{{dashboardTitle}}'?",
            "delete-dashboard-text": "Ole huolellinen. Vahvistettuasi mittaristo ja siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-dashboards-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 mittaristo} other {# mittaristoa} }?",
            "delete-dashboards-action-title": "Poista { count, select, 1 {1 mittaristo} other {# mittaristoa} }",
            "delete-dashboards-text": "Olethan huolellinen. Vahvistettuasi kaikki valitut mittaristot ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "unassign-dashboard-title": "Oletko varma, että haluat poistaa mittariston kohdistuksen '{{dashboardTitle}}'?",
            "unassign-dashboard-text": "Vahvistettuasi mittaristo poistetaan asiakkaalta.",
            "unassign-dashboard": "Poista mittariston kohdistus",
            "unassign-dashboards-title": "Poistetaanko kohdistus { count, select, 1 {1 mittaristo} other {# mittaristoa} }?",
            "unassign-dashboards-text": "Vahvistetuasi kaikki valitut mittaristot poistetaan asiakkaalta.",
            "public-dashboard-title": "Mittaristo on nyt julkinen",
            "public-dashboard-text": "Mittaristo <b>{{dashboardTitle}}</b> on nyt julkinen <a href='{{publicLink}}' target='_blank'>osoitteessa</a>:",
            "public-dashboard-notice": "<b>Huomio:</b> Mittaristoon liittyvät laitteet on myös asetettava julkisiksi, jotta niiden sensoritietoja voidaan esittää.",
            "make-private-dashboard-title": "Oletko varma, että haluat asettaa mittariston '{{dashboardTitle}}' yksityiseksi?",
            "make-private-dashboard-text": "Vahvistettuasi mittaristo asetetaan yksityiseksi ja linkki sen tietohin ei enää toimi kirjautumattomille käyttäjille.",
            "make-private-dashboard": "Aseta mittaristo yksityiseksi",
            "socialshare-text": "'{{dashboardTitle}}' powered by Integral",
            "socialshare-title": "'{{dashboardTitle}}' powered by Integral",
            "select-dashboard": "Valitse mittaristo",
            "no-dashboards-matching": "Vastaavaa mittaristoa: '{{dashboard}}' ei löydy.",
            "dashboard-required": "Mittaristo on pakollinen.",
            "select-existing": "Valitse olemassa oleva mittaristo",
            "create-new": "Luo uusi mittaristo",
            "new-dashboard-title": "Uusi mittariston otsikko",
            "open-dashboard": "Avaa mittaristo",
            "set-background": "Aseta tausta",
            "background-color": "Taustaväri",
            "background-image": "Taustakuva",
            "background-size-mode": "Taustan asetustila",
            "no-image": "Kuvaa ei ole valittu",
            "drop-image": "Vedä kuva tähän tai klikkaa ladataksesi tiedoston.",
            "settings": "Asetukset",
            "columns-count": "Sarakkeiden lukumäärä",
            "columns-count-required": "Sarakkeiden lukumäärä on pakollinen.",
            "min-columns-count-message": "Sarakkeiden vähimmäismäärä on 10.",
            "max-columns-count-message": "Sarakkeiden enimmäismäärä on 1000.",
            "widgets-margins": "Mittaripohjien väli",
            "horizontal-margin": "Vaakasuunta",
            "horizontal-margin-required": "Vaakasuunta-arvo on asetettava.",
            "min-horizontal-margin-message": "Vaakasuunta-arvon vähimmäismäärä on 0.",
            "max-horizontal-margin-message": "Vaakasuunta-arvon enimmäismäärä on 50.",
            "vertical-margin": "Pystysuunta",
            "vertical-margin-required": "Pystysuunta-arvo on asetettava.",
            "min-vertical-margin-message": "Pystysuunta-arvon vähimmäismäärä on 0.",
            "max-vertical-margin-message": "Pystysuunta-arvon enimmäismäärä on 50.",
            "autofill-height": "Aseta korkeus automaattisesti",
            "mobile-layout": "Asetukset mobiililaitteille",
            "mobile-row-height": "Rivin korkeus, px, mobiililaitteessa",
            "mobile-row-height-required": "Rivin korkeus tulee asettaa.",
            "min-mobile-row-height-message": "Korkeus vähintään 5 pikseliä.",
            "max-mobile-row-height-message": "Korkeus enintään 200 pikseliä.",
            "display-title": "Näytä mittariston otsikko",
            "toolbar-always-open": "Pidä työkalunäkymä avoimena",
            "title-color": "Otsikon väri",
            "display-dashboards-selection": "Näytä mittariston valinta",
            "display-entities-selection": "Näytä lähteen valinta",
            "display-dashboard-timewindow": "Näytä aikaväli",
            "display-dashboard-export": "Näytä vie painike",
            "import": "Tuo mittaristo",
            "export": "Lataa mittaristo",
            "export-failed-error": "Mittariston lataus epäonnistui: {{error}}",
            "create-new-dashboard": "Luo uusi mittaristo",
            "dashboard-file": "Mittaristotiedosto",
            "invalid-dashboard-file-error": "Mittariston tuonti epäonnistui: Mittariston tietorakenne ei ole kelvollinen.",
            "dashboard-import-missing-aliases-title": "Tuotavalta mittaristolta puuttuu alias-nimi",
            "create-new-widget": "Luo uusi mittaripohja",
            "import-widget": "Vie mittaripohja",
            "widget-file": "Mittaripohjatiedosto",
            "invalid-widget-file-error": "Mittaripohjan tuonti epäonnistui: Mittaripohja tietorakenne ei ole kelvollinen.",
            "widget-import-missing-aliases-title": "Tuotavalta mittaripohjalta puuttuu alias-nimi",
            "open-toolbar": "Sulje mittariston työkalupalkki",
            "close-toolbar": "Sulje työkalupalkki",
            "configuration-error": "Konfiguraatiovirhe",
            "alias-resolution-error-title": "Asetusvirhe mittariston alias-nimessä",
            "invalid-aliases-config": "Alias-suodatukseen sopivaa laitetta ei löytynyt.<br/>" +
                                      "Ota yhteys järjestelmän ylläpitäjään.",
            "select-devices": "Valitse laitteet",
            "assignedToCustomer": "Kohdistettu asiakkaalle",
            "public": "Julkinen",
            "public-link": "Julkinen linkki",
            "copy-public-link": "Kopioi linkki",
            "public-link-copied-message": "Mittariston julkinen linkki on kopioitu leikepöydälle",
            "manage-states": "Hallinnoi mittariston tiloja",
            "states": "Mittariston tilat",
            "search-states": "Valitse mittariston tilat",
            "selected-states": "{ count, select, 1 {1 dashboard state} other {# dashboard states} } valittu",
            "edit-state": "Muokkaa mittariston tiloja",
            "delete-state": "Poista mittariston tila",
            "add-state": "Lisää mittariston tila",
            "state": "Mittariston tila",
            "state-name": "Nimi",
            "state-name-required": "Mittariston tilalle tulee asettaa nimi.",
            "state-id": "Tilan tunniste",
            "state-id-required": "Mittariston tilan tunniste vaaditaan.",
            "state-id-exists": "Antamasi tilan tunniste on jo käytössä.",
            "is-root-state": "Oletustila",
            "delete-state-title": "Poista mittariston tila",
            "delete-state-text": " Oletko varma, että haluat poistaa mittariston tilan'{{stateName}}'?",
            "show-details": "Näytä tiedot",
            "hide-details": "Piilota tiedot",
            "select-state": "Valitse kohdetila",
            "state-controller": "Tilan ohjain"
        },
        "datakey": {
            "settings": "Asetukset",
            "advanced": "Lisäasetukset",
            "label": "Näyttönimi",
            "color": "Väri",
            "units": "Yksikkö",
            "decimals": "Decimaalit",
            "data-generation-func": "Tiedon luontitoiminto",
            "use-data-post-processing-func": "Käytä tiedon jälkikäsittelytoimintoa",
            "configuration": "Tietoavain asetus",
            "timeseries": "Aikasarjat",
            "attributes": "Attribuutit",
            "alarm": "Hälytyksen kentät",
            "timeseries-required": "Laitteen aikasarja on pakollinen.",
            "timeseries-or-attributes-required": "Laitteen aikasarjat/attribuutit ovat pakolliset.",
            "maximum-timeseries-or-attributes": "Enintään { count, select, 1 {1 timeseries/attribute is allowed.} other {# timeseries/attributes are allowed} }",
            "alarm-fields-required": "Hälytyksen kentät tulee asettaa.",
            "function-types": "Toimintotyypit",
            "function-types-required": "Toimintotyyppi on pakollinen.",
            "maximum-function-types": "Enintään { count, select, 1 {1 function type is allowed.} other {# function types are allowed} }"
        },
        "datasource": {
            "type": "Tietolähteen tyyppi",
            "name": "Nimi",
            "add-datasource-prompt": "Lisää tietolähde"
        },
        "details": {
            "edit-mode": "Muokkaustila",
            "toggle-edit-mode": "Vaihda muokkaustilaa"
        },
        "device": {
            "device": "Laite",
            "device-required": "Laite on pakollinen.",
            "devices": "Laitteet",
            "management": "Laitehallinta",
            "view-devices": "Näytä laitteet",
            "device-alias": "Laitteen alias",
            "aliases": "Laitteen aliakset",
            "no-alias-matching": "'{{alias}}' ei löydy.",
            "no-aliases-found": "Aliasta ei löydy.",
            "no-key-matching": "'{{key}}' ei löydy.",
            "no-keys-found": "Laiteavaimia ei löytynyt.",
            "create-new-alias": "Lisää uusi alias!",
            "create-new-key": "Luo uusi!",
            "duplicate-alias-error": "Samanniminen alias löytyi '{{alias}}'.<br>Laitteen alias-nimi pitää olla mittaristolla yksilöllinen.",
            "configure-alias": "Konfiguroi '{{alias}}' alias",
            "no-devices-matching": "Laitetta '{{device}}' löytynyt.",
            "alias": "Alias",
            "alias-required": "Laitteen alias-nimi on pakollinen.",
            "remove-alias": "Poista laitealias",
            "add-alias": "Lisää laitealias",
            "name-starts-with": "Nimi alkaa merkkijonolla",
            "device-list": "Laiteluettelo",
            "use-device-name-filter": "Käytä suodatinta",
            "device-list-empty": "Laitetta ei valittu.",
            "device-name-filter-required": "Laitenimen suodatus on pakollinen.",
            "device-name-filter-no-device-matched": "Merkkijonolla '{{device}}' ei löydy laitteita.",
            "add": "Lisää laite",
            "assign-to-customer": "Kohdista asiakkaalle",
            "assign-device-to-customer": "Kohdista laite/laitteet asiakkaalle",
            "assign-device-to-customer-text": "Ole hyvä, valitse asiakkaalle kohdistettavat laitteet",
            "make-public": "Aseta julkiseksi",
            "make-private": "Aseta yksityiseksi",
            "no-devices-text": "Laitteita ei löydy",
            "assign-to-customer-text": "Ole hyvä, valitse asiakas, jolle laitteet kohdistetaan",
            "device-details": "Laitteen tiedot",
            "add-device-text": "Lisää uusi laite",
            "credentials": "Valtuutukset",
            "manage-credentials": "Valtuutusten hallinta",
            "delete": "Poista laite",
            "assign-devices": "Kohdista laitteita",
            "assign-devices-text": "Kohdista { count, select, 1 {1 laite} other {# laitetta} } asiakkaalle",
            "delete-devices": "Poista laitteet",
            "unassign-from-customer": "Poista kohdistus asiakkaalta",
            "unassign-devices": "Poista laitteiden kohdistus",
            "unassign-devices-action-title": "Poista { count, select, 1 {1 laite} other {# laitetta} } kohdistus asiakkaalta",
            "assign-new-device": "Kohdista uusi laite",
            "make-public-device-title": "Oletko varma, että haluat asettaa laitteen '{{deviceName}}' julkiseksi?",
            "make-public-device-text": "Vahvistettuasi laite ja sen tiedot asetetaan julkisiksi.",
            "make-private-device-title": "Oletko varma, että haluat asettaa laitteen '{{deviceName}}' yksityiseksi?",
            "make-private-device-text": "Vahvistettuasi laite ja sen tiedot asetetaan yksityisiksi.",
            "view-credentials": "Näytä tunnisteet",
            "delete-device-title": "Oletko varma, että haluat poistaa laitteen '{{deviceName}}'?",
            "delete-device-text": "Olethan varovainen. Vahvistettuasi laite ja kaikki siihen liitetty tieto poistetaan pysyvästi.",
            "delete-devices-title": "Oletko varma, että haluat poistaa laitteet { count, select, 1 {1 laite} other {# laitetta} }?",
            "delete-devices-action-title": "Poista { count, select, 1 {1 laite} other {# laitetta} }",
            "delete-devices-text": "Olethan varovainen. Vahvistettuasi kaikki valitut laitteet ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "unassign-device-title": "Oletko varma, että haluat poistaa laitteen '{{deviceName}}' kohdistuksen?",
            "unassign-device-text": "Vahvistettuasi laite poistetaan asiakkaalta.",
            "unassign-device": "Poista laitteen kohdistus",
            "unassign-devices-title": "Haluatko poistaa kohdistuksen { count, select, 1 {1 laite} other {# laitetta} }?",
            "unassign-devices-text": "Vahvistettuasi kaikki valitut laitteet poistetaan asiakkaalta.",
            "device-credentials": "Laitteen valtuutukset",
            "credentials-type": "Tunnistetyyppi",
            "access-token": "Käyttöoikeustunnus",
            "access-token-required": "Käyttöoikeustunnus on asetettava.",
            "access-token-invalid": "Käyttöoikeustunnuksen pituus on oltava 1-20 merkkiä.",
            "rsa-key": "RSA julkinen avain",
            "rsa-key-required": "RSA julkinen avain on pakollinen.",
            "secret": "Yksityinen",
            "secret-required": "Yksityinen avain vaaditaan.",
            "device-type": "Laitetyyppi",
            "device-type-required": "Laitetyyppi tulee asettaa.",
            "select-device-type": "Valitse laitetyyppi",
            "enter-device-type": "Syötä laitetyyppi",
            "any-device": "Mikä tahansa laite",
            "no-device-types-matching": "Laitetyyppiä '{{entitySubtype}}' ei löytynyt.",
            "device-type-list-empty": "Laitetyyppiä ei ole valittu.",
            "device-types": "Laitetyypit",
            "name": "Nimi",
            "name-required": "Nimi vaaditaan.",
            "description": "Kuvaus",
            "events": "Tapahtumat",
            "details": "Tiedot",
            "copyId": "Kopioi laitteen tunniste",
            "copyAccessToken": "Kopioi Käyttöoikeustunnus",
            "idCopiedMessage": "Laiteen tunniste on kopioitu leikepöydälle",
            "accessTokenCopiedMessage": "Laitteen käyttöoikeustunnus on kopioitu leikepöydälle",
            "assignedToCustomer": "Kohdistettu asiakkaalle ",
            "unable-delete-device-alias-title": "Laitteen aliasta ei voi poistaa",
            "unable-delete-device-alias-text": "Laitteen aliasta '{{deviceAlias}}' ei voi poistaa. Se on käytössä mittaripohjassa:<br/>{{widgetsList}}",
            "is-gateway": "Laite on yhdyskäytävä",
            "public": "Julkinen",
            "device-public": "Laite on julkinen",
            "select-device": "Valitse laite"
        },
        "dialog": {
            "close": "Sulje"
        },
        "error": {
            "unable-to-connect": "Yhteyttä ei voitu muodostaa! Tarkista internet-yhteytesi.",
            "unhandled-error-code": "Käsittelemätön virhe: {{errorCode}}",
            "unknown-error": "Tuntematon virhe"
        },
        "entity": {
            "entity": "Tunniste",
            "entities": "Tunnisteet",
            "aliases": "Tunnisteen näyttönimet",
            "entity-alias": "Tunnisteen näyttönimi",
            "unable-delete-entity-alias-title": "Tunnisteen näyttönimeä ei voitu poistaa",
            "unable-delete-entity-alias-text": "Tunnisteen näyttönimeä '{{entityAlias}}' ei voitu poistaa koska sitä käyttää mittaripohjat: <br/>{{widgetsList}}",
            "duplicate-alias-error": "Samanniminen näyttönimi '{{alias}}’löytyi. <br>Mittaripohjassa käytetyt näyttönimet tulee olla yksilöllisiä.",
            "missing-entity-filter-error": "Näyttönimen '{{alias}}' linkitys laitetunnisteeseen puuttuu.",
            "configure-alias": "Linkitä '{{alias}}' laitetunnisteeseen",
            "alias": "Näyttönimi",
            "alias-required": "Näyttönimi tulee asettaa.",
            "remove-alias": "Poista tunniste näyttönimeltä",
            "add-alias": "Linkitä näyttönimeen tunniste",
            "entity-list": "Lisää tunniste",
            "entity-type": "Tunnisteen tyyppi",
            "entity-types": "Tunnistetyypit",
            "entity-type-list": "Tunnistetyyppien listaus",
            "any-entity": "Tunnisteet",
            "enter-entity-type": "Syötä tunniste",
            "no-entities-matching": "Tunnistetta '{{entity}}' ei löytynyt.",
            "no-entity-types-matching": "Tunnistetyyppiä '{{entityType}}' ei löytynyt.",
            "name-starts-with": "Nimi alkaa",
            "use-entity-name-filter": "Käytä suodatinta",
            "entity-list-empty": "Yhtään tunnistetta ei ole valittuna.",
            "entity-type-list-empty": "Yhtään tunnistetyyppiä ei ole valittuna.",
            "entity-name-filter-required": "Tunnisteen nimisuodatin tulee asettaa.",
            "entity-name-filter-no-entity-matched": "Tunnistetta '{{entity}}' ei löytynyt.",
            "all-subtypes": "Kaikki",
            "select-entities": "Valitse tunnisteet",
            "no-aliases-found": "Näyttönimiä ei löytynyt.",
            "no-alias-matching": "Näyttönimeä ’{{alias}}' ei löytynyt.",
            "create-new-alias": "Luo uusi",
            "key": "Tunniste",
            "key-name": "Tunnisteen nimi",
            "no-keys-found": "Tunnisteita ei löytynyt.",
            "no-key-matching": "Tunnistetta ’{{key}}' ei löytynyt.",
            "create-new-key": "Luo uusi",
            "type": "Tyyppi",
            "type-required": "Tunnisteen tyyppi tulee asettaa.",
            "type-device": "Laite",
            "type-devices": "Laitteet",
            "list-of-devices": "{ count, select, 1 {One device} other {List of # devices} }",
            "device-name-starts-with": "Laitteet, joiden nimi alkaa '{{prefix}}'",
            "type-asset": "Ryhmittely",
            "type-assets": "Ryhmittelyt",
            "list-of-assets": "{ count, select, 1 {One asset} other {List of # assets} }",
            "asset-name-starts-with": "Ryhmittelyt, joiden nimi alkaa '{{prefix}}'",
            "type-rule": "Sääntö",
            "type-rules": "Säännöt",
            "list-of-rules": "{ count, select, 1 {One rule} other {List of # rules} }",
            "rule-name-starts-with": "Säännöt, joiden nimi alkaa '{{prefix}}'",
            "type-plugin": "Liitännäinen",
            "type-plugins": "Liitännäiset",
            "list-of-plugins": "{ count, select, 1 {One plugin} other {List of # plugins} }",
            "plugin-name-starts-with": "Liitännäiset, joiden nimi alkaa '{{prefix}}'",
            "type-tenant": "Ylläpitäjä",
            "type-tenants": "Ylläpitäjät",
            "list-of-tenants": "{ count, select, 1 {One tenant} other {List of # tenants} }",
            "tenant-name-starts-with": "Ylläpitäjät, joiden nimi alkaa '{{prefix}}'",
            "type-customer": "Asiakas",
            "type-customers": "Asiakkaat",
            "list-of-customers": "{ count, select, 1 {One customer} other {List of # customers} }",
            "customer-name-starts-with": "Asiakkaat, joiden nimi alkaa '{{prefix}}'",
            "type-user": "Käyttäjä",
            "type-users": "Käyttäjät",
            "list-of-users": "{ count, select, 1 {One user} other {List of # users} }",
            "user-name-starts-with": "Käyttäjät, joiden nimi alkaa '{{prefix}}'",
            "type-dashboard": "Mittaristo",
            "type-dashboards": "Mittaristot",
            "list-of-dashboards": "{ count, select, 1 {One dashboard} other {List of # dashboards} }",
            "dashboard-name-starts-with": "Mittaristot, joiden nimi alkaa '{{prefix}}'",
            "type-alarm": "Hälytys",
            "type-alarms": "Hälytykset",
            "list-of-alarms": "{ count, select, 1 {One alarms} other {List of # alarms} }",
            "alarm-name-starts-with": "Hälytykset, joiden nimi alkaa '{{prefix}}'",
            "search": "Etsi",
            "selected-entities": "{ count, select, 1 {1 entity} other {# entities} } selected",
            "entity-name": "Tunnisteen nimi",
            "details": "Tunnisteen tiedot",
            "no-entities-prompt": "Tunnisteita ei löytynyt",
            "no-data": "Ei esitettäviä tietoja"
        },
        "event": {
            "event-type": "Tapahtumatyyppi",
            "type-error": "Virhe",
            "type-lc-event": "Elinkaaritapahtuma",
            "type-stats": "Tilastot",
            "no-events-prompt": "Tapahtumia ei löytynyt",
            "error": "Virhe",
            "alarm": "Hälytys",
            "event-time": "Tapahtuman aika",
            "server": "Palvelin",
            "body": "Runko",
            "method": "Menetelmä",
            "event": "Tapahtuma",
            "status": "Tila",
            "success": "Onnistui",
            "failed": "Epäonnistui",
            "messages-processed": "Viestit käsitelty",
            "errors-occurred": "Virhetilanne"
        },
        "fullscreen": {
            "expand": "Laajenna kokonäyttöön",
            "exit": "Poistu kokonäyttötilasta",
            "toggle": "Vaihda kokonäyttötilaa",
            "fullscreen": "Kokonäyttö"
        },
        "function": {
            "function": "Toiminto"
        },
        "grid": {
            "delete-item-title": "Oletko varma, että haluat poistaa nimikkeen?",
            "delete-item-text": "Olethan varovainen. Vahvistettuasi nimike ja siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-items-title": "Oletko varma, että haluat poistaa nimikkeen { count, select, 1 {1 nimike} other {# nimikettä} }?",
            "delete-items-action-title": "Poista nimikkeet { count, select, 1 {1 nimike} other {# nimikettä} }",
            "delete-items-text": "Olethan varovainen. Vahvistettuasi kaikki valitut nimikkeet ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "add-item-text": "Lisää uusi nimike",
            "no-items-text": "Nimikkeitä ei löytynyt",
            "item-details": "Nimikkeen tiedot",
            "delete-item": "Poista nimike",
            "delete-items": "Poista nimikkeet",
            "scroll-to-top": "Siirry ylös"
        },
        "help": {
            "goto-help-page": "Siirry help-sivulle"
        },
        "home": {
            "home": "Etusivu",
            "profile": "Profiili",
            "logout": "Kirjaudu ulos",
            "menu": "Valikko",
            "avatar": "Avatar",
            "open-user-menu": "Avaa käyttäjävalikko"
        },
        "import": {
            "no-file": "Tiedostoa ei ole valittu",
            "drop-file": "Vedä JSON-tiedosto tähän tai klikkaa ladataksesi tiedoston."
        },
        "item": {
            "selected": "Valittu"
        },
        "js-func": {
            "no-return-error": "Toiminnon pitää palauttaa arvo!",
            "return-type-mismatch": "Toiminnon pitää palauttaa '{{type}}' tyyppinen arvo!"
        },
        "layout": {
            "layout": "Ulkoasu",
            "manage": "Hallinnoi ulkoasuja",
            "settings": "Ulkoasun asetukset",
            "color": "Väri",
            "main": "Päänäkymä",
            "right": "Oikeanäkymä",
            "select": "Valitse kohde ulkoasu"
        },
        "legend": {
            "position": "Selitteen sijainti",
            "show-max": "Näytä maksimiarvo",
            "show-min": "Näytä mininimiarvo",
            "show-avg": "Näytä keskiarvo",
            "show-total": "Näytä yhteensä",
            "settings": "Selitteen asetukset",
            "min": "Minimi",
            "max": "Maksimi",
            "avg": "Keskiarvo",
            "total": "Yhteensä"
        },
        "login": {
            "login": "Kirjautuminen",
            "request-password-reset": "Salasanan uudelleen asetus",
            "reset-password": "Nollaa salasana",
            "create-password": "Luo salasana",
            "passwords-mismatch-error": "Syöttämäsi salasanat eivät täsmää!",
            "password-again": "Anna salasana uudelleen",
            "sign-in": "Kirjaudu sisään",
            "username": "Käyttäjätunnus (sähköpostiosoite)",
            "remember-me": "Muista minut",
            "forgot-password": "Unohditko salasanasi?",
            "password-reset": "Salasanan uudelleen asetus",
            "new-password": "Uusi salasana",
            "new-password-again": "Uusi salasana uudelleen",
            "password-link-sent-message": "Linkki salasanan uudelleen asetukseen lähettiin sähköpostiisi!",
            "email": "Sähköposti"
        },
        "plugin": {
            "plugins": "Liitännäiset",
            "delete": "Poista liitännäinen",
            "activate": "Aktivoi liitännäinen",
            "suspend": "Pysäytä liitännäinen",
            "active": "Aktiivinen",
            "suspended": "Pysäytä",
            "name": "Nimi",
            "name-required": "Nimi on pakollinen.",
            "description": "Kuvaus",
            "add": "Lisää liitännäinen",
            "delete-plugin-title": "Oletko varma, että haluat poistaa liitännäisen '{{pluginName}}'?",
            "delete-plugin-text": "Olethan huolellinen. Vahvistettuasi liitännäinen ja siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-plugins-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 liitännäinen} other {# liitännäistä} } liitännäisen?",
            "delete-plugins-action-title": "Poista { count, select, 1 {1 liitännäinen} other {# liitännäistä} } liitännäinen",
            "delete-plugins-text": "Olethan huolellinen. Vahvistettuasi kaikki valitut liitännäiset ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "add-plugin-text": "Lisää uusi liitännäinen",
            "no-plugins-text": "Liitännäisiä ei löydy",
            "plugin-details": "Liitännäisen tiedot",
            "api-token": "API tunnus",
            "api-token-required": "API tunnus vaaditaan.",
            "type": "Liitännäisen tyyppi",
            "type-required": "Liitännäisen tyyppi vaaditaan.",
            "configuration": "Liitännäisen asetukset",
            "system": "Järjestelmä",
            "select-plugin": "Valitse liitännäinen",
            "plugin": "Liitännäinen",
            "no-plugins-matching": "Liitännäistä merkkijonolla '{{plugin}}' ei löydy.",
            "plugin-required": "Liitännäinen vaaditaan.",
            "plugin-require-match": "Ole hyvä, valitse olemassa oleva liitännäinen.",
            "events": "Tapahtumat",
            "details": "Tiedot",
            "import": "Lataa liitännäinen",
            "export": "Vie liitännäinen",
            "export-failed-error": "Liitännäistä ei voitu ladata: {{error}}",
            "create-new-plugin": "Luo uusi liitännäinen",
            "plugin-file": "Liitännäisen tiedosto",
            "invalid-plugin-file-error": "Liitännäistä ei voitu ladata: Liitännäisen tietorakenne ei ole kelvollinen.",
            "copyId": "Kopio liitännäisen tunniste",
            "idCopiedMessage": "Liitännäisen tunniste kopioitu leikepöydälle"
        },
        "position": {
            "top": "Ylhäällä",
            "bottom": "Alhaalla",
            "left": "Vasemmalla",
            "right": "Oikealla"
        },
        "profile": {
            "profile": "Omat tiedot",
            "change-password": "Vaihda salasana",
            "current-password": "Nykyinen salasana"
        },
        "relation": {
            "relations": "Liitokset",
            "direction": "Suunta",
            "search-direction": {
                "FROM": "Sisään",
                "TO": "Ulos"
            },
            "direction-type": {
                "FROM": "sisään",
                "TO": "ulos"
            },
            "from-relations": "Liitokset ulos",
            "to-relations": "Liitokset sisään",
            "selected-relations": "{ count, select, 1 {1 relation} other {# relations} } selected",
            "type": "Tyyppi",
            "to-entity-type": "Kohdetyyppiin",
            "to-entity-name": "Nimiseen kohteeseen",
            "from-entity-type": "Kohdetyypistä",
            "from-entity-name": "Nimisestä kohteesta",
            "to-entity": "Kohteeseen",
            "from-entity": "Kohteesta",
            "delete": "Poista liitos",
            "relation-type": "Liitostyyppi",
            "relation-type-required": "Liitostyyppi tulee asettaa.",
            "any-relation-type": "Kaikki tyypit",
            "add": "Lisää liitos",
            "edit": "Muokkaa liitosta",
            "delete-to-relation-title": "Oletko varma, että haluat poistaa liitoksen kohteeseen '{{entityName}}'?",
            "delete-to-relation-text": "Vahvistettuasi kohteen '{{entityName}}' liitos poistetaan.",
            "delete-to-relations-title": "Oletko varma, että haluat poistaa liitokset kohteisiin { count, select, 1 {1 relation} other {# relations} }?",
            "delete-to-relations-text": "Vahvistettuasi liitokset kohteisiin poistetaan.",
            "delete-from-relation-title": "Oletko varma, että haluaa poistaa liitoksen kohteesta '{{entityName}}'?",
            "delete-from-relation-text": "Vahvistettuasi liitos kohteesta '{{entityName}}' poistetaan.",
            "delete-from-relations-title": "Oletko varma, että haluat poistaa liitokset { count, select, 1 {1 relation} other {# relations} }?",
            "delete-from-relations-text": "Vahvistettuasi liitokset kohteista poistetaan.",
            "remove-relation-filter": "Poista suodatin",
            "add-relation-filter": "Lisää suodatin",
            "any-relation": "Kaikki liitokset",
            "relation-filters": "Suodattimet",
            "additional-info": "Lisäasetukset (JSON)",
            "invalid-additional-info": "Lisäasetusten jäsennys epäonnistui. Tarkista json."
        },
        "rule": {
            "rule": "Sääntö",
            "rules": "Säännöt",
            "delete": "Poista sääntö",
            "activate": "Aktivoi sääntö",
            "suspend": "Keskeytä sääntö",
            "active": "Aktiivinen",
            "suspended": "Keskeytetty",
            "name": "Nimi",
            "name-required": "Nimi tulee asettaa.",
            "description": "Kuvaus",
            "add": "Luo sääntö",
            "delete-rule-title": "Oletko varma, että haluat poistaa säännön '{{ruleName}}'?",
            "delete-rule-text": "Olethan varovainen. Vahvistettuasi sääntö ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-rules-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 sääntö} other {# sääntöä} }?",
            "delete-rules-action-title": "Poista { count, select, 1 {1 sääntö} other {# sääntöä} }",
            "delete-rules-text": "Olethan varovainen. Vahvistettuasi kaikki valitsemasi säännöt ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "add-rule-text": "Luo uusi sääntö",
            "no-rules-text": "Sääntöjä ei löytynyt",
            "rule-details": "Säännön tiedot",
            "filters": "Suodattimet",
            "filter": "Suodatus",
            "add-filter-prompt": "Lisää suodatus, kiitos",
            "remove-filter": "Poista suodatus",
            "add-filter": "Lisää suodatus",
            "filter-name": "Suodatuksen nimi",
            "filter-type": "Suodatuksen tyyppi",
            "edit-filter": "Muokkaa suodatusta",
            "view-filter": "Katso suodatusta",
            "component-name": "Nimi",
            "component-name-required": "Nimi tulee asettaa.",
            "component-type": "Tyyppi",
            "component-type-required": "Tyyppi tulee asettaa.",
            "processor": "Suoritin",
            "no-processor-configured": "Suoritinta ei ole konfiguroitu",
            "create-processor": "Luo suoritin",
            "processor-name": "Suorittimen nimi",
            "processor-type": "Suorittimen tyyppi",
            "plugin-action": "Liitännäisen toimenpide",
            "action-name": "Toimenpiteen nimi",
            "action-type": "Toimenpiteen tyyppi",
            "create-action-prompt": "Luo toimenpide, kiitos",
            "create-action": "Luo toimenpide",
            "details": "Tiedot",
            "events": "Tapahtumat",
            "system": "Järjestelmä",
            "import": "Tuo sääntö",
            "export": "Lataa sääntö",
            "export-failed-error": "Säännön lataus epäonnistui: {{error}}",
            "create-new-rule": "Luo uusi sääntö",
            "rule-file": "Sääntötiedosto",
            "invalid-rule-file-error": "Säännön tuonti epäonnistui: Säännön tietorakenne ei ole kelvollinen.",
            "copyId": "Kopioi säännön tunniste",
            "idCopiedMessage": "Säännön tunniste on kopioitu leikepöydälle.",
            "select-rule": "Valitse sääntö",
            "no-rules-matching": "Sääntöä '{{entity}}' ei löytynyt.",
            "rule-required": "Sääntö vaaditaan"
        },
        "rule-plugin": {
            "management": "Sääntöjen ja liitännäisten hallinta"
        },
        "tenant": {
            "tenant": "Ylläpitäjä",
            "tenants": "Organisaatiot",
            "management": "Organisaatioiden hallinta",
            "add": "Lisää organisaatio",
            "admins": "Ylläpitäjät",
            "manage-tenant-admins": "Hallinnoi ylläpitäjiä",
            "delete": "Poista organisaatio",
            "add-tenant-text": "Lisää uusi organisaatio",
            "no-tenants-text": "Organisaatiota ei löytynyt",
            "tenant-details": "Organisaation tiedot",
            "delete-tenant-title": "Oletko varma, että haluat poistaa organisaation '{{tenantTitle}}'?",
            "delete-tenant-text": "Olethan huolellinen. Vahvistettuasi organisaatio ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-tenants-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 organisaatio} other {# organisaatiota} }?",
            "delete-tenants-action-title": "Poista { count, select, 1 {1 organisaatio} other {# organisaatiota} }",
            "delete-tenants-text": "Olethan huolellinen. Vahvistettuasi valitut organisaatiot ja kaikki niihin liitetyt tiedot poistetaan pysyvästi.",
            "title": "Nimi",
            "title-required": "Nimi tulee asettaa.",
            "description": "Kuvaus",
            "details": "Tiedot",
            "events": "Tapahtumat",
            "copyId": "Kopioi ylläpitäjän tunniste",
            "idCopiedMessage": "Ylläpitäjän tunniste on kopioitu leikepöydälle",
            "select-tenant": "Valitse ylläpitäjä",
            "no-tenants-matching": "Ylläpitäjää '{{entity}}' ei löytynyt.",
            "tenant-required": "Ylläpitäjä vaaditaan"
        },
        "timeinterval": {
            "seconds-interval": "{ seconds, select, 1 {1 sekunti} other {# sekuntia} }",
            "minutes-interval": "{ minutes, select, 1 {1 minuutti} other {# minuuttia} }",
            "hours-interval": "{ hours, select, 1 {1 tunti} other {# tuntia} }",
            "days-interval": "{ days, select, 1 {1 päivä} other {# päivää} }",
            "days": "päivää",
            "hours": "tuntia",
            "minutes": "minuuttia",
            "seconds": "sekuntia",
            "advanced": "Lisäasetus"
        },
        "timewindow": {
            "days": "{ days, select, 1 { päivä } other {# päivää } }",
            "hours": "{ hours, select, 0 { hour } 1 {1 tunti } other {# tuntia } }",
            "minutes": "{ minutes, select, 0 { minuutti } 1 {1 minuutti } other {# minuuttia } }",
            "seconds": "{ seconds, select, 0 { sekunti } 1 {1 sekunti } other {# sekuntia } }",
            "realtime": "Nykyinen",
            "history": "Historia",
            "last-prefix": "edeltävä",
            "period": "alkaen {{ startTime }} saakka {{ endTime }}",
            "edit": "Muokkaa aikaväliä",
            "date-range": "Päivämääräväli",
            "last": "Edelliset",
            "time-period": "Aikajakso"
        },
        "user": {
            "user": "Käyttäjä",
            "users": "Käyttäjät",
            "customer-users": "Käyttäjät",
            "tenant-admins": "Ylläpitäjät",
            "sys-admin": "Järjestelmän ylläpitäjä",
            "tenant-admin": "Ylläpitäjä",
            "customer": "Asiakas",
            "anonymous": "Tuntematon",
            "add": "Lisää käyttäjä",
            "delete": "Poista käyttäjä",
            "add-user-text": "Lisää käyttäjä",
            "no-users-text": "Käyttäjiä ei löytynyt",
            "user-details": "Käyttäjän tiedot",
            "delete-user-title": "Oletko varma, että haluat poistaa käyttäjän '{{userEmail}}'?",
            "delete-user-text": "Vahvistettuasi valittu käyttäjä ja häneen liitetyt tiedot poistetaan pysyvästi",
            "delete-users-title": "Oletko varma, että haluat poistaa { count, select, 1 {1 käyttäjä} other {# käyttäjää} }?",
            "delete-users-action-title": "Poista { count, select, 1 {1 käyttäjä} other {# käyttäjää} }",
            "delete-users-text": "Vahvistettuasi valitut käyttäjät ja niihin liitetyt tiedot poistetaan pysyvästi.",
            "activation-email-sent-message": "Salasanan asetusilmoitus lähetetty onnistuneesti!",
            "resend-activation": "Lähetä aktivointilinkki uudelleen",
            "email": "Sähköpostiosoite",
            "email-required": "Sähköpostiosoite tulee asettaa.",
            "invalid-email-format": "Sähköpostiosoite ei ole kelvollinen.",
            "first-name": "Etunimi",
            "last-name": "Sukunimi",
            "description": "Kuvaus",
            "default-dashboard": "Oletusmittaristo",
            "always-fullscreen": "Aina kokonäytöllä",
            "select-user": "Valitse käyttäjä",
            "no-users-matching": "Käyttäjää '{{entity}}' ei löytynyt.",
            "user-required": "Käyttäjä tulee asettaa",
            "activation-method": "Aktivointi tapa",
            "display-activation-link": "Näytä aktivointilinkki",
            "send-activation-mail": "Lähetä aktivointilinkki",
            "activation-link": "Aktivointilinkki",
            "activation-link-text": "Aktivoidaksesi käyttäjän käytä seuraavaa <a href='{{activationLink}}' target='_blank'>aktivointilinkkiä</a> :",
            "copy-activation-link": "Kopio aktivointilinkki",
            "activation-link-copied-message": "Aktivointilinkki on kopioitu leikepöydälle"
        },
        "value": {
            "type": "Arvon tyyppi",
            "string": "Merkkijono",
            "string-value": "Merkkijonon arvo",
            "integer": "Kokonaisluku",
            "integer-value": "Kokonaislukuarvo",
            "invalid-integer-value": "Virheellinen kokonaislukuarvo",
            "double": "Double",
            "double-value": "Double-arvo",
            "boolean": "Boolean",
            "boolean-value": "Boolean-arvo",
            "false": "Epätosi",
            "true": "Tosi"
        },
        "widget": {
            "widget-library": "Mittarikirjasto",
            "widget-bundle": "Mittaripaketti",
            "select-widgets-bundle": "Valitse mittaripaketti",
            "management": "Mittaripohjan hallinta",
            "editor": "Mittaripohjan muokkaus",
            "widget-type-not-found": "Ongelma mittaripohjan konfiguraation latauksessa.<br>Liittyy mahdollisesti\n    mittarityyppi on poistettu.",
            "widget-type-load-error": "Mittaripohjaa ei ladattu johtuen seuraavista virheistä:",
            "remove": "Poista mittaripohja",
            "edit": "Muokkaa mittaripohjaa",
            "remove-widget-title": "Oletko varma, että haluat poistaa mittaripohjan '{{widgetTitle}}'?",
            "remove-widget-text": "Vahvistettuasi mittaripohja ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "timeseries": "Aikasarja",
            "latest-values": "Viimeisimmät arvot",
            "rpc": "Etäohjausmittari",
            "alarm": "Hälytyspohja",
            "static": "Staattinen mittari",
            "select-widget-type": "Valitse mittarityyppi",
            "missing-widget-title-error": "Mittarin otsikko täytyy asettaa!",
            "widget-saved": "Mittari talletettu",
            "unable-to-save-widget-error": "Mittarin tallennus epäonnistui! Mittarin konfiguraatiossa on virheitä!",
            "save": "Talleta mittari",
            "saveAs": "Talleta mittari nimellä",
            "save-widget-type-as": "Talleta mittarityyppi nimellä",
            "save-widget-type-as-text": "Anna uuden mittarityypin nimi ja/tai valitse sille mittaripaketti.",
            "toggle-fullscreen": "Vaihda kokonäyttöön",
            "run": "Testaa konfiguraatiota",
            "title": "Mittarin otsikko",
            "title-required": "Mittarin otsikko tulee asettaa.",
            "type": "Mittarityyppi",
            "resources": "Resurssit",
            "resource-url": "JavaScript/CSS URL",
            "remove-resource": "Poista resurssi",
            "add-resource": "Lisää resurssi",
            "html": "HTML",
            "tidy": "Siisti",
            "css": "CSS",
            "settings-schema": "Asetusten rakenne",
            "datakey-settings-schema": "Hakuavainasetusten rakenne",
            "javascript": "Javascript",
            "remove-widget-type-title": "Oletko varma, että haluat poistaa mittarityypin '{{widgetName}}'?",
            "remove-widget-type-text": "Vahvistettuasi mittarityyppi ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "remove-widget-type": "Poista mittarityyppi",
            "add-widget-type": "Lisää uusi mittarityyppi",
            "widget-type-load-failed-error": "Mittarityypin lataus epäonnistui!",
            "widget-template-load-failed-error": "Mittaripohjan lataus epäonnistui!",
            "add": "Lisää mittaripohja",
            "undo": "Peruuta mittaripohjan muutokset",
            "export": "Lataa mittaripohja"
        },
        "widget-action": {
            "header-button": "Mittarin otsikkopainike",
            "open-dashboard-state": "Luo uusi mittariston tila",
            "update-dashboard-state": "Muokkaa mittariston tilaa",
            "open-dashboard": "Avaa toinen mittaristo",
            "custom": "Tapauskohtainen",
            "target-dashboard-state": "Kohde mittariston tila",
            "target-dashboard-state-required": "Kohde mittariston tila tulee asettaa",
            "set-entity-from-widget": "Aseta tunniste mittaripohjasta",
            "target-dashboard": "Kohde mittaristo",
            "open-right-layout": "Avaa oikeanpuoleisen mittariston ulkoasu (mobiililaitteet)"
        },
        "widgets-bundle": {
            "current": "Nykyinen paketti",
            "widgets-bundles": "Mittaripaketit",
            "add": "Lisää mittaripaketti",
            "delete": "Poista mittaripaketti",
            "title": "Otsikko",
            "title-required": "Otsikko tulee asettaa.",
            "add-widgets-bundle-text": "Lisää uusi mittaripaketti",
            "no-widgets-bundles-text": "Yhtään mittaripakettia ei löytynyt",
            "empty": "Mittaripaketti on tyhjä",
            "details": "Yksityiskohdat",
            "widgets-bundle-details": "Mittaripaketin yksityiskohdat",
            "delete-widgets-bundle-title": "Oletko varma, että haluat poistaa mittaripaketin '{{widgetsBundleTitle}}'?",
            "delete-widgets-bundle-text": "Olethan huolellinen. Vahvistettuasi mittaripaketti ja kaikki siihen liitetyt tiedot poistetaan pysyvästi.",
            "delete-widgets-bundles-title": "Oletko varma, että haluat poistaa seuraavat { count, select, 1 {1 mittaripaketti} other {# mittaripakettia} }?",
            "delete-widgets-bundles-action-title": "Poista { count, select, 1 {1 mittaripaketti} other {# mittaripakettia} }",
            "delete-widgets-bundles-text": "Olethan huolellinen. Vahvistettuasi kaikki valitut mittaripaketit ja niihin liittyvät tiedot poistetaan pysyvästi.",
            "no-widgets-bundles-matching": "Yhtään mittaripakettia nimellä '{{widgetsBundle}}' ei löytynyt.",
            "widgets-bundle-required": "Mittari paketti tulee asettaa.",
            "system": "Järjestelmä",
            "import": "Tuo mittaripaketti",
            "export": "Lataa mittaripaketti",
            "export-failed-error": "Mittaripaketin lataus epäonnistui: {{error}}",
            "create-new-widgets-bundle": "Luo uusi mittaripaketti",
            "widgets-bundle-file": "Mittaripaketin tiedosto",
            "invalid-widgets-bundle-file-error": "Mittaripaketin tuonti epäonnistui: Mittaripaketin tietorakenne ei ole kelvollinen."
        },
        "widget-config": {
            "data": "Tiedot",
            "settings": "Asetukset",
            "advanced": "Lisäasetukset",
            "title": "Otsikko",
            "general-settings": "Perusasetukset",
            "display-title": "Näytä otsikko",
            "drop-shadow": "Näytä varjo",
            "enable-fullscreen": "Salli kokonäytön asetus",
            "background-color": "Taustaväri",
            "text-color": "Tekstin väri",
            "padding": "Etäisyys kehyksestä",
            "margin": "Marginaali",
            "widget-style": "Mittaripohjan tyyli",
            "title-style": "Otsikon tyyli",
            "mobile-mode-settings": "Asetukset mobiililaitteille",
            "order": "Järjestys",
            "height": "Korkeus",
            "units": "Lukemaan liitettävät merkit tai symbolit",
            "decimals": "Desimaalien määrä",
            "timewindow": "Aikaväli",
            "use-dashboard-timewindow": "Käytä mittariston aikaväliasetusta",
            "display-legend": "Näytä selite",
            "datasources": "Tietolähteet",
            "maximum-datasources": "Enintään { count, select, 1 {1 datasource is allowed.} other {# datasources are allowed} }",
            "datasource-type": "Tyyppi",
            "datasource-parameters": "Parametrit",
            "remove-datasource": "Poista tietolähde",
            "add-datasource": "Lisää tietolähde",
            "target-device": "Kohdelaite",
            "alarm-source": "Hälytyksen lähde",
            "actions": "Tehtävät",
            "action": "Tehtävä",
            "add-action": "Lisää tehtävä",
            "search-actions": "Etsi tehtäviä",
            "action-source": "Tehtävän lähde",
            "action-source-required": "Tehtävän lähde tulee asettaa.",
            "action-name": "Nimi",
            "action-name-required": "Tehtävän nimi tulee asettaa.",
            "action-name-not-unique": "Samanniminen tehtävä löytyi.<br/>Nimen tulee olla yksilöllinen tehtävän lähteen sisällä.",
            "action-icon": "Kuvake",
            "action-type": "Tyyppi",
            "action-type-required": "Tehtävätyyppi tulee asettaa.",
            "edit-action": "Muokkaa tehtävää",
            "delete-action": "Poista tehtävä",
            "delete-action-title": "Poista mittaripohjasta tehtävä",
            "delete-action-text": "Oletko varma, että haluat poistaa mittaripohjaan liitetyn tehtävän '{{actionName}}'?"
        },
        "widget-type": {
            "import": "Tuo mittarityyppi",
            "export": "Lataa mittarityyppi",
            "export-failed-error": "Mittarityypin lataus epäonnistui: {{error}}",
            "create-new-widget-type": "Luo uusi mittarityyppi",
            "widget-type-file": "Mittarityyppi tiedostosta",
            "invalid-widget-type-file-error": "Mittarityypin tuonti epäonnistui: Mittarityypin tietorakenne ei ole kelvollinen."
        },
        "icon": {
            "icon": "Kuvake",
            "select-icon": "Valitse kuvake",
            "material-icons": "kuvakkeet",
            "show-all": "Näytä kaikki kuvakkeet"
        },
        "language": {
            "language": "Kieliasetus",
            "en_US": "Englanniksi",
            "ko_KR": "Koreaksi",
            "fi_FI": "Suomeksi",
            "zh_CN": "Kiinaksi",
            "ru_RU": "Venäjäksi",
            "es_ES": "Espanjan"
        },
        "custom": {
            "widget-action": {
                "action-cell-button": "Tehtävän painike",
                "row-click": "Klikkaa riviä",
                "marker-click": "Klikkaa merkkiä",
                "tooltip-tag-action": "Työkalulla klikkaus"
            }
        }

    };
    angular.extend(locales, {'fi_FI': fi_FI});
}



// WEBPACK FOOTER //
// ./src/app/locale/locale.constant-fi.js